const getInitials = (name: string): string => {
  return name
    .split(/\s+/)
    .slice(0, 2)
    .map(word => word[0].toUpperCase())
    .join('');
};

export { getInitials };
